import Glide, {
  Controls,
  Keyboard,
  Swipe,
  Images,
  Autoplay,
  Breakpoints,
} from '@glidejs/glide/dist/glide.modular.esm';
import { BaseController } from './BaseController';

export default class SliderController extends BaseController {
  id = 'SliderController';

  init() {
    this.root = this.getRoot();

    this.dataAuto = this.getData(this.root, 'autoplay');
    this.isAuto = this.dataAuto && this.dataAuto.length > 0;

    this.dataBreaks = this.getData(this.root, 'breakpoints');

    this.perView = this.getData(this.root, 'perView');

    this.initSlider();
  }

  initSlider = () => {
    let elemsToMount = {
      Controls,
      Keyboard,
      Swipe,
      Images,
    };

    const settings = {
      type: 'carousel',
      startAt: 0,
    };

    if (this.isAuto) {
      elemsToMount = { ...elemsToMount, ...{ Autoplay } };
      settings.autoplay = this.dataAuto;
    }

    if (this.dataBreaks && this.perView) {
      elemsToMount = { ...elemsToMount, ...{ Breakpoints } };
      settings.perView = this.perView;
      settings.breakpoints = {
        600: { perView: 1 },
        900: { perView: 2 },
        1200: { perView: this.perView },
      };
    }

    const glide = new Glide(this.root, settings).mount(elemsToMount);

    if (this.isAuto) {
      glide.play();
      this.root.classList.add('slider-done');
    }
  };
}
